// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Terms & Conditions page (theme-aware) ─────────────────── */
.terms {
  background: var(--bg);
  color: var(--ink);
  min-height: 100vh;
  padding: 32px 0 64px;
}

.terms__back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--line);
  color: var(--ink80);
  border-radius: 999px;
  padding: 7px 14px 7px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color .18s, color .18s, background .18s;
  text-decoration: none;
  margin-bottom: 28px;
}
.terms__back:hover {
  border-color: var(--teal);
  color: var(--teal);
  background: var(--teal-glow);
}

.terms__title {
  font-size: clamp(26px, 4vw, 38px);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  margin-bottom: 10px;
  color: var(--ink);
}

.terms__updated {
  font-size: 12px;
  color: var(--muted);
  margin-bottom: 28px;
}

.terms__intro p {
  font-size: 14px;
  color: var(--ink80);
  line-height: 1.7;
  margin-bottom: 14px;
}

.terms__intro strong { color: var(--ink); }
.terms__intro a { color: var(--teal); text-decoration: underline; text-underline-offset: 2px; }

.terms__divider {
  height: 1px;
  background: var(--line-soft);
  border: none;
  margin: 32px 0;
}

.terms__section {
  margin-bottom: 32px;
}

.terms__section-title {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink);
  margin-bottom: 14px;
  display: flex;
  align-items: baseline;
  gap: 10px;
}
.terms__section-num {
  display: inline-flex;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 8px;
  background: var(--teal-glow);
  color: var(--teal-dark);
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}
[data-theme="dark"] .terms__section-num { color: var(--teal); }

.terms__section p {
  font-size: 14px;
  color: var(--ink80);
  line-height: 1.7;
  margin-bottom: 12px;
}
.terms__section p strong { color: var(--ink); }
.terms__section p a { color: var(--teal); text-decoration: underline; text-underline-offset: 2px; }

.terms__list {
  list-style: none;
  padding: 0;
  margin: 0 0 12px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.terms__list li {
  position: relative;
  padding-left: 22px;
  font-size: 14px;
  color: var(--ink80);
  line-height: 1.65;
}
.terms__list li::before {
  content: "";
  position: absolute;
  left: 6px;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--teal);
}
.terms__list li strong { color: var(--ink); font-weight: 600; }

.terms__footer-note {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid var(--line-soft);
  font-size: 11px;
  color: var(--muted);
  text-align: center;
  letter-spacing: .04em;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Terms.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;EAC1D,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB,iBAAiB,EAAE;AAC1C,kBAAkB,kBAAkB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;;AAE9F;EACE,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;AACA,0CAA0C,kBAAkB,EAAE;;AAE9D;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,2BAA2B,iBAAiB,EAAE;AAC9C,sBAAsB,kBAAkB,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;;AAElG;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;AACA,yBAAyB,iBAAiB,EAAE,gBAAgB,EAAE;;AAE9D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB","sourcesContent":["/* ── Terms & Conditions page (theme-aware) ─────────────────── */\n.terms {\n  background: var(--bg);\n  color: var(--ink);\n  min-height: 100vh;\n  padding: 32px 0 64px;\n}\n\n.terms__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: 1px solid var(--line);\n  color: var(--ink80);\n  border-radius: 999px;\n  padding: 7px 14px 7px 10px;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color .18s, color .18s, background .18s;\n  text-decoration: none;\n  margin-bottom: 28px;\n}\n.terms__back:hover {\n  border-color: var(--teal);\n  color: var(--teal);\n  background: var(--teal-glow);\n}\n\n.terms__title {\n  font-size: clamp(26px, 4vw, 38px);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  margin-bottom: 10px;\n  color: var(--ink);\n}\n\n.terms__updated {\n  font-size: 12px;\n  color: var(--muted);\n  margin-bottom: 28px;\n}\n\n.terms__intro p {\n  font-size: 14px;\n  color: var(--ink80);\n  line-height: 1.7;\n  margin-bottom: 14px;\n}\n\n.terms__intro strong { color: var(--ink); }\n.terms__intro a { color: var(--teal); text-decoration: underline; text-underline-offset: 2px; }\n\n.terms__divider {\n  height: 1px;\n  background: var(--line-soft);\n  border: none;\n  margin: 32px 0;\n}\n\n.terms__section {\n  margin-bottom: 32px;\n}\n\n.terms__section-title {\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n  margin-bottom: 14px;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n}\n.terms__section-num {\n  display: inline-flex;\n  min-width: 28px;\n  height: 28px;\n  padding: 0 8px;\n  border-radius: 8px;\n  background: var(--teal-glow);\n  color: var(--teal-dark);\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n}\n[data-theme=\"dark\"] .terms__section-num { color: var(--teal); }\n\n.terms__section p {\n  font-size: 14px;\n  color: var(--ink80);\n  line-height: 1.7;\n  margin-bottom: 12px;\n}\n.terms__section p strong { color: var(--ink); }\n.terms__section p a { color: var(--teal); text-decoration: underline; text-underline-offset: 2px; }\n\n.terms__list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 12px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.terms__list li {\n  position: relative;\n  padding-left: 22px;\n  font-size: 14px;\n  color: var(--ink80);\n  line-height: 1.65;\n}\n.terms__list li::before {\n  content: \"\";\n  position: absolute;\n  left: 6px;\n  top: 9px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--teal);\n}\n.terms__list li strong { color: var(--ink); font-weight: 600; }\n\n.terms__footer-note {\n  margin-top: 40px;\n  padding-top: 20px;\n  border-top: 1px solid var(--line-soft);\n  font-size: 11px;\n  color: var(--muted);\n  text-align: center;\n  letter-spacing: .04em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
